<template>
  <div style="width: 100%">
    <highcharts :options="Pie()"></highcharts>
  </div>
</template>

<script>
export default {
  props: ["title", "data"],
  methods: {
    Pie() {
      let chart = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          style: {
            fontFamily: "Mitr",
          },
        },
        colors:
          this.title === "Social summary"
            ? this.data.colors
            : [
                "#96c6f2",
                // "#90CAF9",
                "#56a4ea",
                // "#42A5F5",
                "#1a81df",
                // "#1976D2",
                "#135c9f",
                // "#0D47A1",
                "#0f4a7f",
                // "#90CAF9",
                "#07253f",
                "#00116b",
                // "#90CAF9",
                "#0011db2",
                // "#42A5F5",
                "#0029f9",
                // "#1976D2",
                "#4261ff",
                // "#0D47A1",
                "#899dff",
                // "#90CAF9",
                "#74b8f0",
              ],
        title: {
          useHTML: true,
          text: this.title,
          style: {
            'word-break': "break-word",
            "text-align": "center",
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat: "",
          pointFormat: this.data.pointFormat,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              useHTML: true,
              format: "<b>{point.percentage:.1f} %",
            },
            showInLegend: true,
          },
        },
        legend: {
          useHTML: true,
        },
        series: this.data.data,
      };
      return chart;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>